<div class="events-dialog">
  <div class="events-dialog-header">
    <button class="button button--icon" mat-icon-button aria-label="Close" mat-dialog-close>
      <lib-icon icon="x"></lib-icon>
    </button>
  </div>

  <div class="events-dialog-body">
    <div class="event-info">
      <div class="event-title">
        {{ event.name }}
      </div>

      <div class="event-date">
        <label class="event-field-label">
          {{ 'LEARNER_CALENDAR.date_and_time' | translate }}
        </label>

        <label class="event-field-value">
          {{ event.date | customDate }}
          <span class="event-date-separator"></span>
          {{ event.date | customDate : 'shortTime' }}
        </label>
      </div>

      <button class="export-button button button--primary" mat-flat-button [exportCalendar]="event">
        <lib-icon icon="calendar-check"></lib-icon>
        {{ 'COMMON.add_to_calendar' | translate }}
      </button>

    </div>

    @if (event.mediaImage) {
      <img class="event-image" [cropImage]="event.mediaImage | preSignedUrl | async" alt="Event image" />
    } @else {
      <div class="event-image default" [ngStyle]="{ backgroundImage: $any(event) | offlineActivityImage }"></div>
    }


  </div>

  <div class="event-description">
    <label class="event-field-label">
      {{ 'LEARNER_CALENDAR.about_event' | translate }}
    </label>

    <span class="event-field-value" [innerHTML]="event.description | safeHtml"></span>
  </div>
</div>
